export default __webpack_public_path__ + "b7e5595ab0381610b598c42f92fe1215.png";